import { render, staticRenderFns } from "./EmailComplete.vue?vue&type=template&id=66a7477f&lang=pug&"
import script from "./EmailComplete.vue?vue&type=script&lang=ts&"
export * from "./EmailComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports